import { helperDoc, uploadIcon } from 'assets/icons'
import { InputText } from 'primereact/inputtext'
import React, { useRef } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as myconst from "../../constants/index"
import { setbrandGuidelineName, setsocialMediaPostName } from 'redux/counterSlice';
import { MultiSelect } from 'primereact/multiselect';

interface Options {
    name: string;
    // value: string;
}

const BrandPersonality = ({ handlePrev, handleNext, methods }: any) => {
    const fileInputRef: any = useRef(null);
    const fileInputRef2: any = useRef(null);
    const dispatch = useDispatch();
    const brandGuidelineName = useSelector((state: any) => state.counter.brandGuidelineName);
    const socialMediaPostName = useSelector((state: any) => state.counter.socialMediaPostName);
    const { formState: { errors }, setValue, trigger, getValues } = useFormContext();
    const handleButtonClick = (file: any) => {
        // Trigger the file input when the button is clicked
        file.current.click();
    };
    const PersonalityOptions: Options[] = [
        { name: "Adventurousness" },
        { name: "Competence" },
        { name: "Excitement" },
        { name: "Innovativeness" },
        { name: "Nurturing" },
        { name: "Playfulness" },
        { name: "Ruggedness" },
        { name: "Sincerity" },
        { name: "Sophistication" },
        { name: "Youthfulness" }
    ];
    const PersonalityTraitsOptions: Options[] = [
        { name: "Adaptable" },
        { name: "Adventurous" },
        { name: "Altruistic" },
        { name: "Approachable" },
        { name: "Articulate" },
        { name: "Assertive" },
        { name: "Authentic" },
        { name: "Bold" },
        { name: "Brave" },
        { name: "Calm" },
        { name: "Cautious" },
        { name: "Charming" },
        { name: "Clever" },
        { name: "Comfortable" },
        { name: "Competitive" },
        { name: "Confidence" },
        { name: "Cool" },
        { name: "Creative" },
        { name: "Curious" },
        { name: "Daring" },
        { name: "Dependable" },
        { name: "Disciplined" },
        { name: "Diligent" },
        { name: "Dynamic" },
        { name: "Efficient" },
        { name: "Elegant" },
        { name: "Empathetic" },
        { name: "Fresh" },
        { name: "Friendly" },
        { name: "Fun" },
        { name: "Generous" },
        { name: "Genuine" },
        { name: "Glamorous" },
        { name: "Grounded" },
        { name: "Honest" },
        { name: "Humble" },
        { name: "Human" },
        { name: "Humorous" },
        { name: "Inclusive" },
        { name: "Independent" },
        { name: "Innovative" },
        { name: "Inspiring" },
        { name: "Intuitive" },
        { name: "Inviting" },
        { name: "Kindness" },
        { name: "Loyal" },
        { name: "Meticulous" },
        { name: "Nurturing" },
        { name: "Open" },
        { name: "Optimistic" },
        { name: "Outdoorsy" },
        { name: "Passion" },
        { name: "Passionate" },
        { name: "Patient" },
        { name: "Perceptive" },
        { name: "Playful" },
        { name: "Practical" },
        { name: "Punctual" },
        { name: "Relaxed" },
        { name: "Reliable" },
        { name: "Resilient" },
        { name: "Respectful" },
        { name: "Romantic" },
        { name: "Self-aware" },
        { name: "Sincere" },
        { name: "Simple" },
        { name: "Sociable" },
        { name: "Spontaneous" },
        { name: "Strategic" },
        { name: "Strong" },
        { name: "Supportive" },
        { name: "Tenacious" },
        { name: "Thoughtful" },
        { name: "Tough" },
        { name: "Trendy" },
        { name: "Upper class" },
        { name: "Vibrant" },
        { name: "Visionary" },
        { name: "Warm" },
        { name: "Witty" },
        { name: "Winner" },
        { name: "Zealous" }
    ];
    const handleFileChangeBrandGuideline = async (event: any) => {
        const file = event.target.files[0];
        const size = Math.round(event?.target?.files[0]?.size / 1048576);
        const fileType = file?.name?.split('.').pop();
        if (file) {
            if (size < 10) {
                if (file && file?.type === "application/pdf") {
                    // if (fileTypes.includes(file.type)) {
                    const base64Code: any = await myconst.fileToBase64(file)
                    const correctBase64 = await myconst.manipulateBase64Data(base64Code)
                    dispatch(setbrandGuidelineName(file?.name));
                    setValue("brand_guide_file", correctBase64);
                    toast.success("Document uploaded successfully", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    })
                } else {
                    fileInputRef.current.value = null;
                    // dispatch(setbrandGuidelineName(''));
                    toast.error("File is not supported", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    })
                }
            } else {
                fileInputRef.current.value = null;
                // dispatch(setbrandGuidelineName(''));
                toast.error("File size should not be more than 10 MB", {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        }
    }
    const handleFileChangeSocialMediaPost = async (event: any) => {
        const file = event.target.files[0];
        const size = Math.round(event?.target?.files[0]?.size / 1048576);
        const fileType = file?.name?.split('.').pop();
        if (file) {
            if (size < 10) {
                if (file && file?.type === "application/pdf") {
                    // if (fileTypes.includes(file.type)) {
                    const base64Code: any = await myconst.fileToBase64(file)
                    const correctBase64 = await myconst.manipulateBase64Data(base64Code)
                    dispatch(setsocialMediaPostName(file?.name));
                    setValue("social_media_file", correctBase64);
                    toast.success("Document uploaded successfully", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    })
                } else {
                    fileInputRef.current.value = null;
                    // dispatch(setsocialMediaPostName(''));
                    toast.error("File is not supported", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    })
                }
            } else {
                fileInputRef.current.value = null;
                // dispatch(setsocialMediaPostName(''));
                toast.error("File size should not be more than 10 MB", {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        }
    }

    const getFormErrorMessage = (name: string) => {
        return (
            errors[name] && (
                <small className="p-error">{errors[name]?.message?.toString()}</small>
            )
        )
    }

    const handleNextButton = async () => {
        let isValid: boolean = false;
        isValid = await trigger(['traits', 'personalities']);
        const brandFile = getValues("brand_guide_file");
        const socialFile = getValues("social_media_file");
        if (isValid && brandFile !== "" && brandFile !== undefined && socialFile !== "" && socialFile !== undefined) {
            handleNext();
        } else {
            if ((brandFile === "" || brandFile === undefined) && (socialFile === "" || socialFile === undefined)) {
                toast.error("Please upload both the Brand Guideline and Social Media Post documents")
            } else if ((brandFile === "" || brandFile === undefined) && (socialFile !== "" && socialFile !== undefined)) {
                toast.error("Please upload the Brand Guideline document")
            } else if ((brandFile !== "" && brandFile !== undefined) && (socialFile === "" || socialFile === undefined)) {
                toast.error("Please upload the Social Media Post document")
            }
        }
    }
    return (
        <div className='step-preview-wrap'>
            <div className='stepper-main'>
                <div className='stepper-form'>
                    <div className='stepper-wrapper'>
                        {/* <div className='form-row'>
                            <div className='form-col'>
                                <div className='upload-file-step'>
                                    <label className="form-label">Brand Guideline<i>*</i></label>
                                    <div className='home-search' onClick={() => handleButtonClick(fileInputRef)}>
                                        <InputText style={{ cursor: "auto" }} value={brandGuidelineName.length >= 42 ? `${brandGuidelineName.slice(0, 42)}...` : brandGuidelineName} className='radius-input input-box' placeholder='Upload Brand Guideline' readOnly title={brandGuidelineName} />
                                        <input id='uploadDoc' ref={fileInputRef} type="file" placeholder='Upload document' onChange={handleFileChangeBrandGuideline} className="d-none" accept='application/pdf' name="fileUpload" />
                                        <i className='last-icon'><img src={uploadIcon} alt='upload-icon' /></i>
                                    </div>
                                    <p className='helper-text'><i><img src={helperDoc} alt='qmate-icon' /></i>Only PDF files with a maximum file size limit of <b>10 MB.</b></p>
                                </div>
                            </div>
                            <div className='form-col'>
                                <div className='upload-file-step'>
                                    <label className="form-label">Social Media Post<i>*</i></label>
                                    <div className='home-search' onClick={() => handleButtonClick(fileInputRef2)}>
                                        <InputText style={{ cursor: "auto" }} value={socialMediaPostName.length >= 42 ? `${socialMediaPostName.slice(0, 42)}...` : socialMediaPostName} className='radius-input input-box' placeholder='Upload Social Media Post' readOnly title={socialMediaPostName} />
                                        <input id='uploadDoc' ref={fileInputRef2} type="file" placeholder='Upload document' onChange={handleFileChangeSocialMediaPost} className="d-none" accept='application/pdf' name="fileUpload" />
                                        <i className='last-icon'><img src={uploadIcon} alt='upload-icon' /></i>
                                    </div>
                                    <p className='helper-text'><i><img src={helperDoc} alt='qmate-icon' /></i>Only PDF files with a maximum file size limit of <b>10 MB.</b></p>
                                </div>
                            </div>
                        </div> */}
                        <div className='form-row'>
                            <div className='form-col'>
                                <div className='upload-file-step'>
                                    <label className="form-label">Personality<i>*</i></label>
                                    <Controller
                                        name="personalities"
                                        control={methods.control}
                                        rules={{
                                            required: "Personality is required"
                                        }}
                                        render={({ field }) => (
                                            <MultiSelect
                                                {...field}
                                                id="yourDropdownId" // Replace with your desired ID
                                                options={PersonalityOptions}
                                                value={field.value}
                                                showSelectAll={false}
                                                resetFilterOnHide={true}
                                                filter
                                                optionLabel="name"
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 2) {
                                                        setValue("personalities", e.target.value, { shouldValidate: true });
                                                    } else {
                                                        toast.error("You can't select more than two Personalities")
                                                    }
                                                }}
                                                placeholder="Select Personality"
                                                className={`outline-select`}
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("personalities")}
                                </div>
                            </div>
                            <div className='form-col'>
                                <div className='upload-file-step'>
                                    <label className="form-label">Personality Traits<i>*</i></label>
                                    <Controller
                                        name="traits"
                                        control={methods.control}
                                        rules={{
                                            required: "Personality Traits is required"
                                        }}
                                        render={({ field }) => (
                                            <MultiSelect
                                                {...field}
                                                id="yourDropdownId" // Replace with your desired ID
                                                options={PersonalityTraitsOptions}
                                                value={field.value}
                                                showSelectAll={false}
                                                resetFilterOnHide={true}
                                                filter
                                                optionLabel="name"
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 2) {
                                                        setValue("traits", e.target.value, { shouldValidate: true });
                                                    } else {
                                                        toast.error("You can't select more than two Personality Traits")
                                                    }
                                                }}
                                                placeholder="Select Personality Traits"
                                                className={`outline-select`}
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("traits")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='stepper-footer'>
                    <div className='stepper-wrapper stepper-wrapper-ft'>
                        <div className='stepper-footer-inner'>
                            <div className='stepper-footer-left'></div>
                            <div className='stepper-footer-right'>
                                <button type="button" className="grey-outline-btn mr-4" onClick={() => handlePrev()}>Previous</button>
                                <button type="button" className="outline-active-btn" onClick={handleNextButton}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BrandPersonality